export const fieldType = {
  Image: "image",
  Text: "text",
  TextSourse: "textSource",
};

export const fieldsType = {
  name: {
    type: fieldType.Text,
  },

  capital: {
    type: fieldType.Text,
  },

  flag: {
    type: fieldType.Image,
  },

  COA: {
    type: fieldType.Image,
  },

  map: {
    type: fieldType.Image,
  },

  domain: {
    type: fieldType.TextSourse,
  },
};
